// packages import
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, CircularProgress, DialogActions } from "@mui/material"
import { FC, useContext } from "react"
import { FormProvider, SubmitHandler, useForm } from "react-hook-form"
// component import
import { Alert } from "../common/Alert"
import { CustomController } from "../common/CustomController"
import { CustomModal } from "../common/CustomModal"
// others
import { CreateCaseTypeInput, useCreateCaseTypeMutation } from "../../../generated"
import { CANCEL } from "../../constants"
import { AppContext } from "../../context"
import { ActionType } from "../../context/AppContextReducer"
import { AddNewCaseTypeProps, ErrorException } from "../../interfaceTypes"
import { createCaseTypeValidationSchema } from "../../validationSchema"

export const AddNewCaseType: FC<AddNewCaseTypeProps> = ({ refetch, lawTypeId }) => {
  const { isOpen, dispatch } = useContext(AppContext)

  const methods = useForm<CreateCaseTypeInput>({
    mode: "all",
    resolver: yupResolver(createCaseTypeValidationSchema),

    defaultValues: {
      name: '',
    }
  })

  const { handleSubmit, reset } = methods;

  const [createCaseTypeMutation, { loading }] = useCreateCaseTypeMutation({
    onError({ graphQLErrors }) {
      if (graphQLErrors) {
        graphQLErrors.map(
          // eslint-disable-next-line
          ({ extensions }) => {
            if (extensions) {
              const { exception } = extensions;
              if (exception) {
                const { response } = exception as ErrorException
                const { response: errorResponse } = response || {}
                if (errorResponse) {
                  const { error } = errorResponse
                  Alert.error(error)
                }
              }
            }
          })
      }
    },

    onCompleted(data) {
      if (data) {
        refetch && refetch()
        Alert.success('Case type created successfully')
        reset()
        handleClose()
      }
    }
  })

  const onSubmit: SubmitHandler<CreateCaseTypeInput> = async (data: CreateCaseTypeInput) => {
    const { name } = data

    if (lawTypeId) {
      await createCaseTypeMutation({
        variables: {
          createCaseTypeInput: {
            name,
            lawTypeId,
          }
        }
      })
    }
  }

  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })

  return (
    <CustomModal title='Add New Case Type' isOpen={isOpen} handleClose={handleClose}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
          <CustomController
            controllerName='name'
            controllerLabel='Title'
            fieldType='text'
          />

          <DialogActions sx={{ padding: '30px 0 0' }}>
            <Button onClick={handleClose} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

            <Button type="submit" color='primary' variant="contained" disabled={loading} aria-label='add case type'
              endIcon={loading && <CircularProgress size={20} color="inherit" />}>
              Add Case Type
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </CustomModal>
  )
}